<template>
  <div class="ele-body">
    <el-card shadow="never" header="节次设置">
      <ele-data-table ref="sectionTable" border :data="sectionData" :config="sectionTable" highlight-current-row>
        <el-table-column label="节次" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-select v-if="$index === sectionIndex" v-model="sectionForm.section" placeholder="请选择节次" class="ele-fluid">
              <el-option label="第1节" :value="1" />
              <el-option label="第2节" :value="2" />
              <el-option label="第3节" :value="3" />
              <el-option label="第4节" :value="4" />
              <el-option label="第5节" :value="5" />
              <el-option label="第6节" :value="6" />
              <el-option label="第7节" :value="7" />
              <el-option label="第8节" :value="8" />
              <el-option label="第9节" :value="9" />
              <el-option label="第10节" :value="10" />
            </el-select>
            <span v-else>第{{ row.section }}节</span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-time-picker v-if="$index === sectionIndex" v-model="sectionForm.beginTime" placeholder="开始时间" value-format="HH:mm" />
            <span v-else>{{ row.beginTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-time-picker v-if="$index === sectionIndex" v-model="sectionForm.endTime" placeholder="结束时间" value-format="HH:mm" />
            <span v-else>{{ row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130px" align="center" :resizable="false">
          <template #default="{ row, $index }">
            <div v-if="$index === sectionIndex">
              <el-link @click="onSaveRow(row, $index)" icon="el-icon-check" type="success" :underline="false">保存</el-link>
              <el-link @click="onCancelRow(row, $index)" icon="el-icon-close" type="warning" :underline="false">取消</el-link>
            </div>
            <div v-else>
              <el-link @click="onEditRow(row, $index)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
            </div>
          </template>
        </el-table-column>
      </ele-data-table>
      <el-button @click="addRow" icon="el-icon-plus" style="width: 100%; margin-top: 15px">新增节次</el-button>
    </el-card>
  </div>
</template>

<script>
  import { getCourseSectionList, setCourseSection } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        sectionTable: {
          page: false,
        },
        sectionData: [],
        sectionIndex: null,
        sectionForm: {},
      };
    },
    mounted() {
      this.getSectionData();
    },
    methods: {
      // 获取节次列表
      getSectionData() {
        getCourseSectionList().then((res) => {
          if (res.data.resCode == 200) {
            this.sectionData = res.data.data;
          }
        });
      },
      //添加节次
      addRow() {
        if (this.sectionData.length == 0) {
          this.sectionData.push({ __is_add: true });
          this.sectionForm = {};
          this.sectionIndex = 0;
        }
        if (this.sectionData[this.sectionData.length - 1].__is_add) return;
        this.sectionData.push({ __is_add: true });
        this.sectionForm = {};
        this.sectionIndex = this.sectionData.length - 1;
      },
      // 修改行
      onEditRow(row, index) {
        this.sectionIndex = index;
        this.sectionForm = Object.assign({}, row);
      },
      // 取消编辑
      onCancelRow(row, index) {
        if (row.__is_add) this.sectionData.splice(index, 1);
        this.sectionIndex = null;
        this.sectionForm = {};
      },
      //保存
      onSaveRow(row, index) {
        if (!this.sectionForm.section) return this.$message.error('请选择节次！');
        if (!this.sectionForm.beginTime) return this.$message.error('请选择开始时间！');
        if (!this.sectionForm.endTime) return this.$message.error('请选择结束时间！');
        let data = new FormData();
        for (let key in this.sectionForm) {
          if (this.sectionForm[key] !== null && this.sectionForm[key] !== undefined) {
            data.append(key, this.sectionForm[key]);
          }
        }
        setCourseSection(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.getSectionData();
            this.sectionData[index] = Object.assign({}, this.sectionForm, {
              __is_add: false,
            });
            this.sectionIndex = null;
            this.sectionForm = {};
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
